import { createHelpers } from 'vuex-map-fields';
import Echo from "laravel-echo";
window.io = require("socket.io-client");

const { getUserField, updateUserField } = createHelpers({
    getterType: 'getUserField',
    mutationType: 'updateUserField',
});

const state = {
    module: {
        is_load: false,
        is_filter_load : false,
    },

    tender_user : {
        id: 0,
        cur_rights : "",
    },

    user: {
        id: 0,
        client_id:0,
        is_portal : false,
        guest: 1,
        status: "need_sms",
        need_captcha: true,
        'currency' : {
            'suffix' : "₴"
        },
        subscribes : [],

    },
    tender_settings : {
        "company" : "",
        "contact_name" : "",
        "contact_tel"  : "",
        "subscription_deactivated" : false,
        "verifed" : true,
    },



};

const getters = {

    getUser(state) {
        return state.user;
    },

    getUserId(state) {
        return state.user.id;
    },

    getUserTenderSettings(state) {
        return state.tender_settings;
    },

    getUserModule(state) {
        return state.module;
    },

    getUserField,
};

// actions
const actions = {
    async LOAD_USER({commit}) {
        await api.get('/tenders/me').then(({data}) => {
            state.module.is_load = true;
            if(data.status === "operation_success") {
                let data_push = data.data;
                commit('addUser',data_push);

                if(data_push.hasOwnProperty("settings")) {
                    commit('addTenderUserSettings',data_push.settings)
                }
            }
        }).catch(e => {
            console.log(e);
        })
    },

    async LOAD_TENDER_USER({commit}) {
        await axios.get('/internal/user/me').then(({data}) => {
            state.module.is_load = true;
            if(data.status === "operation_success") {
                let data_push = data.data;
                commit('addTenderUser',data_push);

            }
        }).catch(e => {
            console.log(e);
        })
    },


};

// mutations
const mutations = {
    updateUserField,

    addTenderUserSettings(state,data) {
        state.tender_settings = {...state.tender_settings,...data}
    },

    addTenderUser(state,dat) {
        state.tender_user = {...state.tender_user,...data};
    },

    addUser(state,data) {

        state.user = {...state.user,...data};
        state.user.is_portal = false;

        if(data.hasOwnProperty("settings")) {
            state.user.is_portal = true;
        }

        if(data.hasOwnProperty('token')) {
         /*   let echo  = new Echo({
                broadcaster: "socket.io",
                host: 'https://api.imcagro.com',
                csrfToken: '',
                debug: true,
                bearerToken: data.token,
                auth: {
                    headers: {
                        Accept: 'application/json',
                    }
                }
            });*/

            try {
               /* echo.private("customer." + data.client_id)
                    .listen('.order.add', (e) => {
                        if (localStorage.getItem('is_debug')) {
                            console.log('order.add', e);
                        }
                    })
                    .listen('.order.state', (e) => {
                        if (localStorage.getItem('is_debug')) {
                            console.log('order.state', e);
                        }
                    });*/
            } catch (e) {
                console.log('err',e);
            }
        }

        EventBus.$emit('user_loaded',true);
        state.module.is_load = true;
    },

    setUserField(state,data) {
        state.user = {...state.user,...data};
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
